import styles from '../style.module.scss';

/**
 * Table of vacancy links; each row opens the detail modal.
 */
export function VacancyList({ vacancies, onSelectVacancy }) {
  return (
    <table
      className={styles.tableTdBorder}
      role='grid'
      aria-label='Posizioni aperte'
    >
      <tbody>
        {vacancies.map((vacancy) => (
          <tr key={vacancy.id}>
            <td>
              <button
                type='button'
                className={styles.vacancyLink}
                onClick={() => onSelectVacancy(vacancy.id)}
              >
                {vacancy.label}
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
